module.exports = __webpack_public_path__ + "img/lowRiskMarker.44b8e1a4.svg";